import validate from 'lib/utils/validationRules';

import Attachment from 'lib/project/classes/Attachment';
import BillTariff from './BillTariff';

class BillForm {
  constructor() {
    this.amount = '';
    this.isMulti = true;
    this.isContentUrl = false;
    this.contentUrl = '';
    this.description = null;
    this.attachment = new Attachment;
    this.billTariffs = [new BillTariff];
    this.currency = null;
    this.type = 'CASUAL';
  }

  getData() {
    return {
      type: this.type,
      multiBill: this.isMulti,
      description: this.description || null,
      attachment: this.attachment.getData(),
      billTariffs: this.billTariffs.map(tariff => {
        return {
          id: tariff.id,
          name: tariff.name,
          description: tariff.description || null,
          amount: tariff.getAmount(this.currency),
          currency: this.currency,
          contentUrl: this.getTariffContentUrl(tariff),
          subscription: null,
        };
      }),
    };
  }

  getTariffContentUrl(tariff) {
    if (!this.isContentUrl) {
      return null;
    }

    const { contentUrl } = tariff;
    const checkProtocol = contentUrl.match(/^http[s]?:\/\//);
    const checkOnIframeTag = /^<iframe.+<\/iframe>$/.test(contentUrl);

    if (checkOnIframeTag) {
      return contentUrl;
    }

    if (validate.isNull(checkProtocol)) {
      return `https://${contentUrl}`;
    }

    return contentUrl;
  }
}

export default BillForm;
